export const routes = {
    CreateItem: '/createItem',
    Home: '/',
    Items: '/items',
  };